export const MAIN_CARD_CONTAINER_CLASS = "flex flex-col sm:flex-row gap-4 mx-3";
export const FIRST_CARD_CONTAINER_CLASS =
    "flex flex-col sm:w-2/3 justify-between gap-4";
export const SECOND_CARD_CONTAINER_CLASS =
    "sm:w-1/3 overflow-hidden border-2 border-New_Primary_Default";
export const LOGO_CONTAINER_CLASS =
    "border border-New_Primary_Default h-20 sm:h-1/4 flex justify-center items-center ";
export const ARTICLE_CONTAINER_CLASS =
    "flex flex-col border border-New_Primary_Default h-[354px] xs:min-h-[290px] xl:h-3/4 py-6 xl:py-8 px-6 xl:px-20";
export const ARTICLE_TEXT_CONTAINER_CLASS =
    "flex-1 flex flex-col justify-center";
export const ARTICLE_BUTTON_CLASS = "!text-New_Primary_Default";
export const START_QOUTES_CLASS = "w-6 lg:w-8";
export const END_QOUTES_CONTAINER_CLASS = "flex justify-end";
export const END_QOUTES_CLASS = "w-6 lg:w-8";
export const MODEL_IMAGE_CLASS = "w-full h-full scale-105 object-cover";
